import {
  useDuplicateLifeAreaSection,
  useTransformLifeAreaSectionToGoal,
} from 'features/life-areas';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ArrowRight16,
  CopyDuplicateObject,
  Edit3,
  Target,
  Trash2,
} from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { LifeArea } from 'shared/types/life-area';

export type EditListProps = {
  lifeArea: LifeArea;
  sectionId: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  openGoalSelect: () => void;
  onClose: () => void;
  onDeleteSection: () => void;
};

export const EditList: React.FC<EditListProps> = ({
  lifeArea,
  sectionId,
  inputRef,
  openGoalSelect,
  onClose,
  onDeleteSection,
}) => {
  const { t } = useTranslation();
  const duplicateSection = useDuplicateLifeAreaSection();
  const transformToGoal = useTransformLifeAreaSectionToGoal();

  const onTransferSection = (e: React.MouseEvent) => {
    e.preventDefault();
    openGoalSelect();
  };

  const onEditName = (e: React.MouseEvent) => {
    e.preventDefault();
    inputRef?.current?.focus();
    onClose();
  };

  const onDuplicateSection = (e: React.MouseEvent) => {
    e.preventDefault();
    duplicateSection(sectionId, lifeArea);
    onClose();
  };

  const onTransformToGoal = (e: React.MouseEvent) => {
    e.preventDefault();
    transformToGoal(sectionId, lifeArea);
    onClose();
  };

  return (
    <PopupMenuList hasBottomBorder>
      {!!inputRef && (
        <PopupMenuListItem>
          <PopupMenuButton onClick={onEditName} start={<Icon icon={Edit3} />}>
            {t('context-menus.goal.section.labels.edit')}
          </PopupMenuButton>
        </PopupMenuListItem>
      )}
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onDuplicateSection}
          start={<Icon icon={CopyDuplicateObject} />}
        >
          {t('context-menus.goal.section.labels.duplicate')}
        </PopupMenuButton>
      </PopupMenuListItem>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onTransferSection}
          start={<Icon icon={ArrowRight16} />}
        >
          {t('context-menus.goal.section.labels.move-to-other-goal')}
        </PopupMenuButton>
      </PopupMenuListItem>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onTransformToGoal}
          start={<Icon icon={Target} />}
        >
          {t('context-menus.goal.section.labels.turn-into-goal')}
        </PopupMenuButton>
      </PopupMenuListItem>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onDeleteSection}
          start={<Icon icon={Trash2} />}
        >
          {t('context-menus.goal.section.labels.delete')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
